var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartners3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 56,
    viewBox: "0 0 81 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3208_5974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.713501,
    width: 79.573,
    height: 56,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3208_5974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.26511,
    y: -8,
    width: 66.6192,
    height: 72,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3208_5974",
    transform: "matrix(0.0125671 0 0 0.0178571 -0.0403846 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3208_5974",
    width: 86,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAA4CAYAAABnqA/dAAAD+UlEQVR4nO2av2/bRhTHv092qkhGArmwhyytxmiqgc5C08lrnNlB/Se4HduhzpKxSbfCU4pmjtLRUxNoDpBOzmY7iwcJEV3DlljE9+1A0j6RlE2KR4ZW7zPxx927x3dP7727E2CxWCwWi8VisVgsPpJVwGDIP2KEHkCh01iQNwDguPyRCq1IZ6Ijc7gb+85/v1iXF8GtM+JvJBYIbH9ek25W3SPDkfQvX4vIvSyy5g3o40F0AICCOoBVVLB5eMwf7tySXrhNwNkcdisKPSHeAQAEa3q7sznsBm0/DNkmsQAA4rUzbliTGDPsmGe5/IIKrRufYQlAL65NHIMh1ya1E8GaEKcK6Aqx+mHIdh5eawpjhh24nlFEYYkKLSq8X6rJblybgMWqjHnwJPouW1BYVsCO+xE7N+exCqCNEnutMcMKzuPklwCACk5I1kXk9LyRwoNQt0SGrSgvRLgfsXPnlvQGI74R4uu+y9ZSdXzyyoIxwzaq8ji4PhpxVRHrRy7WAWwHzxdr8jCt3MNjLgeTdnMevwyGBPwUM0+0Acy2YQNI1p1/UQ8+Xucfl3f1+zOF4WJNDi6TV7uBNRIQQZcKfe1Vm0D78JidsQRZEszFWL/sckbevQCnJHb0NmcKP+n3UsEugMeYAMm6M0IbRL9Rk2393dGIJ4pYr3rx9rmZrzBHdsOGSigKeqqCvh77lEL3vKTSUArjnhaS5YywDKIjRMSrb1fRdYZYmKvgJPM3WPKFF7zKKqtiQiFLFGvYnLCGzYnMhmV6BiR/vkTeCsm/UsjbI7kyQVYjjaystjAKyWdprKoR2T3yDTGYQtaeYd1Kkbw2ATwCoiXRFcRty60AaEyhQzNuogB8N4Ws6wXJ+1d5bA5jBuyTvHLCTHpsIdD7ie9pij8taNxUhipbKEjCJoCmf30AYKugcWcXks1QCLhf4Ngz7bHPtOs/ReRlAWN+cnI1rO+d3/i3RwA28hyvTORmWD8LP9EebYmIk9d4ZcP4RreGnrBei8iVlQDJJqavPX8Xkf0p+14PQgnL8Q2WpN+9uGVQQuJWcjOXvPSE9XTmPSmGPM689IT1t4ikqVnfAvh2yqHfTtmv/DC6worddSpQn5kJBXrCeiQis+tFRRFKWIk2PQrQaSY8Vk9YG/+nmjUOI4YluYGLhPWriFyPbbcyw/Fdf6cMISAgzU/b/45ShYItXOz6lzUEfJVgwo3uY2T+Rzc5dgiXZKYdTAgXfnn2JNolEd+Hq5CQbg4m17pNXFQzgIF/dGeG5Kvo6jIRcUvQ8N5tUmJDUAbdNoux3iXQi00vp1A+dkVG72xsP4WcfV5+/J1Wt0KOjSwWi8VisVgsFovFkpX/ALhFO5mP3zJ0AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners3);
export default __webpack_public_path__ + "static/media/partners3.8acead4460ebe7fb5d550cc1c676f500.svg";
export { ForwardRef as ReactComponent };